<template>
  <header class="navbar">
    <div class="left">
      <img class="company-logo global-margin global-inner mr-auto" src="../../assets/logo1.png" alt="三川田"
        @click="hangty" />
    </div>
    <div class="right" v-show="screenWidth > 1024">
      <Menu :swidth="screenWidth" :attr="virtual && hasOverHeight" :menuList="menuList"></Menu>
    </div>
    <div class="right-m" v-show="screenWidth <= 1024">
      <div class="flex items-center">
        <ul class="flex flex-wrap menu-ul">
          <li class="flex-11t">
            <span v-for="(item, index) in languageColumns" :key="index" @click="setLang(item.value)"
              :class="[$i18n.locale == item.value ? 'active-navbar' : '']">{{ item.text }}</span>
          </li>
        </ul>
        <div>
          <i class="el-icon-menu navbar-m-icon" v-show="!showMobilePop" @click="showMobilePop = true"></i>
          <i class="el-icon-close navbar-m-icon" v-show="showMobilePop" @click="showMobilePop = false"></i>
        </div>
      </div>
      <Menu-mobile v-if="screenWidth <= 1024 && showMobilePop" @closeMobile="closeMobile" :menuList="menuList" />
    </div>
  </header>
</template>

<script>
import Menu from "./Menu.vue";
import MenuMobile from "./MenuMobile.vue";
import { setNowRoute } from '../../js/nowRoute'
import { languageColumns } from '../../locale/utils'
// import { getCookies } from "@/assets/js/cookies";
export default {
  name: "NavBar",
  props: {
    virtual: {
      // 头部是否可虚化
      type: Boolean,
      default: true,
    },
    maxTop: {
      // 头部最大的虚化高度
      type: Number,
      default: 880,
    },
    screenWidth: {
      type: Number,
    }
  },
  data() {
    return {
      hasOverHeight: true, // 是否超出需要虚化的高度
      name: "",
      lang: "zh_cn",
      showMobilePop: false,
      languageColumns: languageColumns,
      menuList: [{
        path: '/',
        title: this.$t('navbar.home')
      }, {
        path: '/template',
        title: this.$t('navbar.cy')
      }, {
        path: '/solution',
        title: ''
      }, {
        path: '/industryPavilionCase',
        title: ''
      }, {
        path: '/creativeInteraction',
        title: ''
      }, {
        path: '/news',
        title: ''
      }, {
        path: '/aboutUs',
        title: ''
      }, {
        path: '/contact',
        title: this.$t('navbar.contact')
      },],
    };
  },
  components: { Menu, MenuMobile },
  created() {

    this.lang = localStorage.getItem("333f-locale-lang") || "zh_cn";
    this.$http.get('/common/category/getList', {
      pid: 0,
      lang_code: this.lang,
      'to-tree': 0
    }).then((res) => {
      if (res.code == 200) {
        this.menuList[2].title = res.data[0].category_name
        this.menuList[3].title = res.data[1].category_name
        this.menuList[4].title = res.data[2].category_name
        this.menuList[5].title = res.data[3].category_name
        this.menuList[6].title = res.data[4].category_name
      } else {
        this.loading = false
        // this.$message.error(res.msg);
      }
    });
  },
  beforeMount() {
    // window.addEventListener("scroll", this.$_scrollHeader);
    // this.getName();
  },
  beforeUnmount() {
    // window.removeEventListener("scroll", this.$_scrollHeader);
  },
  mounted() {
    // 提醒过后端后台加路由绑定,拒绝
    setNowRoute(this.$route.name)
  },
  methods: {
    setLang(item) {
      if (!item) return
      this.$i18n.locale = item
      localStorage.setItem('333f-locale-lang', item)
      location.reload()
    },
    closeMobile() {
      this.showMobilePop = false
    },
    // $_scrollHeader() {
    //   const screenHeight =
    //     document.documentElement.scrollTop || document.body.scrollTop; // 获取滚动的垂直方向上的位移
    //   const scrollLeft = Math.max(
    //     document.body.scrollLeft,
    //     document.documentElement.scrollLeft
    //   ); // 获取滚动的水平方向上的位移
    //   // document.querySelector(".NavBar").style.left = `-${scrollLeft}px`;
    //   if (screenHeight > this.maxTop) {
    //     this.hasOverHeight = false;
    //   } else {
    //     this.hasOverHeight = true;
    //   }
    // },
    toLogin() {
      this.$router.push("/sign_in");
    },
    hangty() {
      this.$router.push("/");
    },
    // getName() {
    //   let user = getCookies("userInfo");
    //   if (user) {
    //     user = JSON.parse(user);
    //     this.name =
    //       user.tel.substr(0, 3) + "****" + user.tel.substr(user.tel.length - 4);
    //   }
    // },
    changeLang(lang) {
      // this.lang = lang;
      // this.$i18n.locale = localStorage.getItem("333f-locale-lang");
      // localStorage.setItem("333f-locale-lang", lang);
      // location.reload();
      // window.translate.changeLanguage(lang);
    },
  },
};
</script>

<style lang="less" scoped>
.navbar {
  position: fixed;
  top: 0;
  z-index: 1000;
  display: flex;
  width: 100%;
  height: 80px;
  min-width: 100%;
  padding: 0 40px 0 0;
  background-color: #fff;
  box-sizing: border-box;
  justify-content: space-between;
  align-items: center;
  background-color: rgba(0, 0, 0, 0.7);
  /* background: radial-gradient(black, #353535); */
  backdrop-filter: saturate(180%) blur(10px);
}

.company-logo {
  width: 216px;
  height: 40px;
}

.right {
  display: flex;
  align-items: center;

}

.right-m {
  .menu-ul {
    margin-right: 30px;

    li {
      span {
        font-size: 20px;
        color: #fff;
      }
    }

    .active-navbar {
      /* height: 70px; */
      /* border-bottom: 4px solid #ff5715; */
      color: @primaryColor;
      font-weight: bold;
    }
  }

  .navbar-m-icon {
    font-size: 36px;
    color: #fff;

  }
}
</style>



// WEBPACK FOOTER //
// src/components/navBar/Navbar.vue